var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobalTechnology(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Global_Tech") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Builder-MVP",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Settings_Themes",
    transform: "translate(-1008.000000, -373.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Global_Tech",
    transform: "translate(1008.000000, 373.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#08F27B",
    x: 0,
    y: 0,
    width: 8.39999986,
    height: 8.39999986
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#0F1F41",
    x: 8.39999986,
    y: 0,
    width: 8.39999986,
    height: 8.39999986
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B4FBD7",
    x: 8.39999986,
    y: 8.39999986,
    width: 8.39999986,
    height: 8.39999986
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B3BBC6",
    x: 0,
    y: 8.39999986,
    width: 8.39999986,
    height: 8.39999986
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalTechnology);
export default __webpack_public_path__ + "static/media/globalTechnology.a8d0cc0180ee28b501a358af82d9291c.svg";
export { ForwardRef as ReactComponent };